import { Catalog, PartMetadata } from "../../interfaces/PartsCatalog";

export const defaultCatalogObject: Catalog = {
	enabled: false,
	autoOpen: false,
	title: "Parts Catalog",
	highlightColor: "#ffffff",
	partData: {
		displayName: "#ObjectName",
		metadata: []
	}
};

export const defaultPartMetadataItem: PartMetadata = {
	id: "",
	name: "Metadata ",
	data: "#meta",
}